<template>
    <div class="text-center">
        <div v-if="title"><label class="label">{{ title }}</label><br></div>
        <font-awesome-icon class="loader" icon="sync-alt" :style="{ color: color }" spin />
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, default: null, required: false },
        color: { type: String, default: "#000000", required: false },
    }
}
</script>

<style lang="scss" scoped>
.loader {
    font-size: 2rem;
}
</style>